<template>
    <div class="spotlight-fade" :style="spotlightStyle"></div>
</template>
  
  <script setup>
  import { ref, onMounted, onBeforeUnmount } from 'vue';
  
  const spotlightStyle = ref({
    top: '0px',
    left: '0px',
  });
  
  const updateSpotlightPosition = (event) => {
    const spotlightSize = 100; // ขนาดของ spotlight (ครึ่งหนึ่งของขนาดที่กำหนดใน CSS)
    spotlightStyle.value.top = `${event.clientY - spotlightSize}px`;
    spotlightStyle.value.left = `${event.clientX - spotlightSize}px`;
  };
  
  onMounted(() => {
    document.addEventListener('mousemove', updateSpotlightPosition);
  });
  
  onBeforeUnmount(() => {
    document.removeEventListener('mousemove', updateSpotlightPosition);
  });
  </script>
  
  <style lang="scss" scoped>
    @import "@/assets/scss/app";
   
    .spotlight-fade {
      position: absolute;
      width: 260px;
      height: 260px;
      border-radius: 50%;
      background: radial-gradient(circle 120px, rgba($yellow-ci, 1), transparent);
      filter: blur(75px);
      pointer-events: none; 
      transition: transform 0.1s ease; 
      z-index: -1;

    }
 
  </style>